// @flow
import IconButton from "@mui/material/IconButton";
import * as React from 'react';
import Box from "@mui/material/Box";
import {Popover} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import CheckListInfo from "./checkListInfo";

type Props = {

};

const InfoPopOver = ({infoPopOver, handleInfoPopOver}: Props) => {
	const handlePopOverClose = () => {
		handleInfoPopOver({anchorEl: null, open: false, body: ''})
	}
	return (
		<React.Fragment>
			<Box onClick={(e) => e.stopPropagation()}>
				<Popover
					disableRestoreFocus
					onClose={handlePopOverClose}
					open={infoPopOver.open}
					anchorEl={infoPopOver.anchorEl}
					anchorOrigin={{
						vertical: 'top',
						horizontal: 'center',
					}}
					transformOrigin={{
						vertical: 'bottom',
						horizontal: 'center',
					}}
				>
					<Box sx={{width: '100%'}}>
						<Box sx={{
							width: '100%',
							display: 'flex',
							justifyContent: 'space-between',
							flexWrap: "wrap-reverse",
							gap: 0.2
						}}>
							<IconButton
								onClick={handlePopOverClose}
								color={'error'}
								size={'small'}
								sx={{ marginLeft: 'auto' }}
							>
								<ClearIcon/>
							</IconButton>
						</Box>
						<CheckListInfo />
					</Box>
				</Popover>
			</Box>
		</React.Fragment>
	);
};

export default InfoPopOver